import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  limit: 50,
  page: 1,
  total: 0,
  totalPages: 1,
};

export const contractPaginateSlice = createSlice({
  name: "contractPaginateSlice",
  initialState,
  reducers: {
    setPageLimit: (state, action) => {
      state.limit = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    setTotalCount: (state, action) => {
      state.total = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    resetPagination: (state, action) => {
      state.limit = 50;
      state.page = 1;
      state.total = 0;
      state.totalPages = 1;
    },
  },
});

export const {
  setPageLimit,
  setCurrentPage,
  setTotalCount,
  setTotalPages,
  resetPagination,
} = contractPaginateSlice.actions;

export default contractPaginateSlice.reducer;
